module.exports = __webpack_public_path__ + "static/media/outgoing.92881e15.ico";